// @flow

import { RestClientAuthenticated } from '../network';
import { turanBaseURL } from '../../utils/urlUtils';

const mediaApi = {
  fetchMedia: (id: string) => new RestClientAuthenticated(`${turanBaseURL()}/keepeek/media/${id}`, 'GET').execute(),
};

export default mediaApi;
